<careposi-modal-template class="add-edit-auto-recording-dialog" *ngIf="isDisplayModal" [modalTemplate]="modalData"
  (closeModalHandler)="onClose()">
  <div modal-body>
    <div class="content header">
      <div class="title"></div>
    </div>
    <div class="content-login">
      <div class="office-box">
        <div class="office-contain-logo">
          <img class="office-img" src="images/logo/super-logo.svg">
        </div>
        <div class="content-dialog">
          @if(hasErr){ <label class="office-error-msg" >{{TEXT_LOGIN.LOGIN_ERR_MSG}}</label><br> }
            <div class="office-login-title">{{OFFICE_SELECTION.LABEL}}</div>
            <div class="office-corp-list">
              @for(office of officeList; track office){
                <ng-container>
                    <careposi-text-button [tooltipEnabled]="true" class="office-corp-button {{office.disable ? cssDisable: ''}}" [buttonType]="buttonType.SECONDARY" [buttonText]="office?.officenm ??''"
                        (btnClick)="onChoose(office, false)" [disabled]="office.disable">
                    </careposi-text-button>
                </ng-container>
              }
        </div>
        <a (click)="onBack()" class="btn-back">別の法人に切り替える</a>
        <div class="error">{{errBack}}</div>
      </div>
    </div>
  </div>
  </div>
  <div modal-bottom class="content-footer"></div>
</careposi-modal-template>
